import { render, staticRenderFns } from "./UpdatePFAC.vue?vue&type=template&id=575f851e"
import script from "./UpdatePFAC.vue?vue&type=script&lang=js"
export * from "./UpdatePFAC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports